if (!customElements.get('roadspec-sticky-purchase')) {
  class RoadSpecStickyPurchase extends HTMLElement {
    connectedCallback() {
      this.sourceButton = document.getElementById(this.dataset.sourceButton);
      this.stickyButton = this.querySelector('[data-sticky-submit]');
      this.sourceVariantInput = document.querySelector(`#product-form-${this.sourceButton?.id.replace('ProductSubmitButton-', '')} .product-variant-id`);
      this.stickyVariantInput = this.querySelector('.rsp-sticky-variant-id');
      if (!this.sourceButton || !this.stickyButton) return;

      this.updateButtonState = () => {
        const unavailable = this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.disabled = unavailable;
        const sourceLabel = this.sourceButton.querySelector('span')?.textContent?.trim();
        const stickyLabel = this.stickyButton.querySelector('span');
        if (sourceLabel && stickyLabel) stickyLabel.textContent = sourceLabel;
        if (this.sourceVariantInput && this.stickyVariantInput) {
          this.stickyVariantInput.value = this.sourceVariantInput.value;
          this.stickyVariantInput.disabled = this.sourceVariantInput.disabled;
        }
      };

      this.setVisible = (visible) => {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('rsp-sticky-purchase-visible', visible);
      };

      this.updateVisibility = () => {
        const sourceRect = this.sourceButton.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const sourceAboveViewport = sourceRect.bottom < 0;
        const sourceBelowViewportAfterScroll = window.scrollY > 80 && sourceRect.top > viewportHeight;
        this.setVisible(sourceAboveViewport || sourceBelowViewportAfterScroll);
      };

      this.purchaseObserver = new IntersectionObserver(
        this.updateVisibility,
        { threshold: 0.05 }
      );
      this.buttonObserver = new MutationObserver(this.updateButtonState);

      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      window.addEventListener('resize', this.updateVisibility);
      this.purchaseObserver.observe(this.sourceButton);
      this.buttonObserver.observe(this.sourceButton, { attributes: true, childList: true, subtree: true });
      if (this.sourceVariantInput) this.buttonObserver.observe(this.sourceVariantInput, { attributes: true });
      this.updateButtonState();
      this.updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateVisibility);
      window.removeEventListener('resize', this.updateVisibility);
      this.purchaseObserver?.disconnect();
      this.buttonObserver?.disconnect();
      document.body.classList.remove('rsp-sticky-purchase-visible');
    }
  }

  customElements.define('roadspec-sticky-purchase', RoadSpecStickyPurchase);
}
